export const ANNOUNCEMENT_TYPE = {
  LANDING: 'LANDING',
  NOTIFICATION: 'NOTIFICATION',
};

export const ANNOUNCEMENT_CATEGORY = {
  COURSE: 'COURSE',
  COURSE_WITH_EMAIL: 'COURSE_WITH_EMAIL',
  COURSE_WITH_PUSH_NOTIFICATION: 'COURSE_WITH_PUSH_NOTIFICATION',
  COURSE_WITH_PUSH_NOTIFICATION_AND_EMAIL: 'COURSE_WITH_PUSH_NOTIFICATION_AND_EMAIL',
  NEWS: 'NEWS',
  REMINDER: 'REMINDER',
  POPUP: 'POPUP',
};

export const AUDIENCE_TYPE = {
  GLOBAL: 'GLOBAL',
  PROVIDER: 'PROVIDER',
  COURSE: 'COURSE',
  USER: 'USER',
};
